import { createContext } from "react";
const defaultContext = {
  activeTab: "",
  setActiveTab: () => ""
};
const TabContext = createContext(defaultContext);
export default TabContext;
